import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const urlPrefix = "/plugins/org.graylog.plugins.securityapp.investigations/investigations/summary";
const fetchAIReport = (investigationId) => fetch("GET", qualifyUrl(`${urlPrefix}/${investigationId}`)).then(
  (report) => report == null ? void 0 : report.text
);
const useAiReport = (investigationId, enabled) => {
  const { data, isLoading, isFetching, isSuccess, isFetched, isError, error } = useQuery({
    queryKey: ["investigation-ai-report", investigationId],
    queryFn: () => defaultOnError(
      fetchAIReport(investigationId),
      "Fetching AI Report failed with status",
      "Could not fetch AI Report"
    ),
    enabled
  });
  return {
    data,
    isLoading,
    isFetching,
    isSuccess,
    isFetched,
    isError,
    error
  };
};
export default useAiReport;
